import React, {Component} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import {injectRoute} from "@irati/utils/helpers/routing"
import {READY_TO_LAUNCH} from "@irati/insights/constants/schedule"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"

import {ActionsWrapper, Footer} from "../../components/Wizard"
import sitemap from "../../routes/sitemap"
import ValidateController from "../../components/Wizard/Validate/ValidateController"


class ScheduleEditSummary extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired
  }

  getFooter = (schedule, handleClick, load) => {
    const {id: scheduleId, validationStatus} = schedule
    const isReadyToLaunch = validationStatus === READY_TO_LAUNCH
    return (
      <Footer pullRight>
        <ActionsWrapper marginRight>
          <ButtonRouterLink to={injectRoute(sitemap.scheduleEdit.url, {scheduleId})}>
            <FormattedMessage id="insights.wizard.step3.cta.back" />
          </ButtonRouterLink>
        </ActionsWrapper>

        <ActionsWrapper>
          {
            isReadyToLaunch
              ? <ValidationButton load={load} onClick={handleClick} primary>
                <FormattedMessage id="insights.wizard.step3.cta.next" />
              </ValidationButton>
              : <ButtonRouterLink to={sitemap.homepage.url} primary>
                <FormattedMessage id="insights.wizard.cta.homepage" />
              </ButtonRouterLink>
          }
        </ActionsWrapper>
      </Footer>
    )
  }


  render() {
    const idNamespace = id("ScheduleEditSummary", this.props, {force: true})
    const {match} = this.props
    const {scheduleId} = match.params
    const backToRoute = injectRoute(sitemap.scheduleEdit.url, {scheduleId})

    return (
      <ValidateController
        id={idNamespace}
        match={match}
        scheduleId={scheduleId}
        backToRoute={backToRoute}
        isEdit
        renderFooter={this.getFooter} />
    )
  }
}

export default ScheduleEditSummary
